import React from "react";
import { Modal } from "react-bootstrap";
import "./header.scss";
import { Link } from "react-router-dom";
import { AppStore, PlayStore } from "../../../assets/svgImages/svgImages";
import { useTranslation } from "react-i18next";

interface UserProfileModalProps {
  show: boolean;
  userProfileHide: () => void;
}

const UserProfileModal: React.FC<UserProfileModalProps> = ({
  userProfileHide,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      {...props}
      aria-labelledby="user-profile-modal"
      centered
      onHide={userProfileHide}
      className="user-profile-modal"
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div className="user-profile-wrapper">
          <h4 className="">
            {t("please-download-your")} Renticy App {t("through-your-profile")}
          </h4>
          <div className="d-flex justify-content-center">
            <Link
              target="_blank"
              to={
                "https://play.google.com/store/apps/details?id=com.renticy&hl=en"
              }
              className="play-store-link me-md-2 me-1"
            >
              <PlayStore className="play-store-svg" />
            </Link>
            <Link
              target="_blank"
              to={
                "https://apps.apple.com/in/app/renticy/id6514299223?platform=ipad"
              }
              className="play-store-link ms-md-2 ms-1"
            >
              <AppStore className="play-store-svg" />
            </Link>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UserProfileModal;
